import React, {Component} from "react"

export default class StatsRow extends Component {
  render() {
    return (
      <div className="sh-stats-row">
        <h3>{this.props.title}</h3>
        <div className="container">
          {React.Children.map(this.props.children, (item, index) =>
            this.renderItem(
              item.props.label,
              item.props.number,
              item.props.percentage || false
            )
          )}
        </div>
      </div>
    )
  }

  renderItem(label, number, percentage) {
    return (
      <div className="sh-stats-row-item">
        <div className="stat">
          {percentage ? Math.round(number * 100) : number}
          {percentage === true && <span className="percentage">%</span>}
        </div>
        <div className="label">{label}</div>
      </div>
    )
  }
}
StatsRow.Item = ""



// WEBPACK FOOTER //
// ./src/components/decorators/StatsRow.js